<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <HxHeader
        :header-text="headerText"
        :breadcrumb-items="isSelected ? items : items.slice(0, 3)"
        :chips="showChips ? chips : []"
      />
      <template #configuration>
        <div class="d-flex flex-column mt-16">
          <hx-checkbox v-model="isSelected" :label="`More Items: ${isSelected}`"></hx-checkbox>
          <hx-checkbox v-model="showChips" :label="`Show chips: ${showChips}`"></hx-checkbox>
        </div>
      </template>
    </UsageExample>
  </v-container>
</template>
<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixHeader',
  components: { UsageExample },
  setup() {
    const code = `
    <hx-header
      :header-text="headerText"
      :breadcrumb-items="items"
      :chips="chips"
    />
    `;
    return {
      code
    };
  },
  data() {
    return {
      tab: 'Header Usage',
      tabs: ['Header Usage'],
      isSelected: true,
      showChips: true,
      items: [
        {
          text: 'Home',
          key: 'Home',
          to: '/',
          disabled: false
        },
        {
          text: 'Student Duty of Care',
          key: 'Student Duty of Care',
          to: '/',
          disabled: false
        },
        {
          text: 'Executive Summary',
          key: 'Executive Summary',
          to: '/module/276/page/ReadMe.md',
          disabled: false
        },
        {
          text: 'Contextualisation Guide',
          key: 'Contextualisation Guide',
          to: '/module/276/page/abc.md',
          disabled: false
        }
      ],
      headerText: 'Helix Header',
      chips: [
        { label: 'All', color: 'pink', leftIcon: 'mdi-triangle' },
        { label: 'Active', color: 'green' },
        { label: 'Inactive', color: 'grey' },
        { label: 'Pending', color: 'yellow' },
        { label: 'Completed', color: 'blue' },
        { label: 'Archived', color: 'red' }
      ]
    };
  }
};
</script>
